// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1LFyH","error":"Textarea_error__1dTX9","readonly":"Textarea_readonly__3kuRh","disabled":"Textarea_disabled__2Y07q"};